<svelte:options runes={true} />

<script lang="ts">
	import * as ResizablePrimitive from 'paneforge';
	import { cn } from '@ui-lib/utils/utils';

	interface Props {
		class?: ResizablePrimitive.PaneGroupProps['class'];
		direction: ResizablePrimitive.PaneGroupProps['direction'];
		children?: import('svelte').Snippet;
		paneGroup?: ResizablePrimitive.PaneGroupAPI;
		ref?: HTMLDivElement | null;
		[key: string]: any;
	}

	let {
		class: className = undefined,
		direction,
		paneGroup = $bindable(undefined),
		ref = $bindable(undefined),
		children,
		...rest
	}: Props = $props();

	let localPaneGroup: ResizablePrimitive.PaneGroupAPI | undefined = $state(undefined);
	let localRef: HTMLDivElement | null = $state(null);

	$effect(() => {
		paneGroup = localPaneGroup;
	});

	$effect(() => {
		ref = localRef;
	});
</script>

<ResizablePrimitive.PaneGroup
	bind:ref={localRef}
	bind:this={localPaneGroup}
	{direction}
	class={cn('flex h-full w-full data-[direction=vertical]:flex-col', className)}
	{...rest}
>
	{@render children?.()}
</ResizablePrimitive.PaneGroup>
